import Tiptap from '@UI/Tiptap/Component';
import s from './index.module.css';
import cn from 'classnames';

const InputWhite = ({
    //name,
    value,
    onChange,
    placeholder,
    className,
    isTiptap = false,
    ...props
}) => {
    return (<>
        { !isTiptap && <input
            className={cn(s.input, className)}
            value={value}
            placeholder={placeholder}
            onChange={onChange}
            { ...props }
            /> }
        { isTiptap && <Tiptap />}
    </>);
}

export default InputWhite;